import { useAuth } from '@/react-app/contexts/AuthContext';

export type UserRole = 'owner' | 'receptionist';

export interface Permissions {
  // Gestão de usuários
  canManageUsers: boolean;
  
  // Configurações do sistema
  canManageSettings: boolean;
  
  // Gestão de quartos
  canCreateRooms: boolean;
  canEditRooms: boolean;
  canDeleteRooms: boolean;
  
  // Relatórios financeiros
  canViewFinancialReports: boolean;
  canViewRevenue: boolean;
  
  // Gestão de estoque
  canManageInventory: boolean;
  canViewInventoryCosts: boolean;
  
  // Operações básicas (todos podem fazer)
  canCheckIn: boolean;
  canCheckOut: boolean;
  canCreateReservations: boolean;
  canViewRooms: boolean;
  canRegisterConsumption: boolean;
}

export const usePermissions = (): Permissions => {
  const { user } = useAuth();
  
  const userRole = (user?.user_type as UserRole) || 'receptionist';
  
  const isOwner = userRole === 'owner';
  
  return {
    // Apenas proprietário pode gerenciar usuários
    canManageUsers: isOwner,
    
    // Apenas proprietário pode alterar configurações
    canManageSettings: isOwner,
    
    // Gestão de quartos - apenas proprietário
    canCreateRooms: isOwner,
    canEditRooms: isOwner,
    canDeleteRooms: isOwner,
    
    // Relatórios financeiros - apenas proprietário
    canViewFinancialReports: isOwner,
    canViewRevenue: isOwner,
    
    // Gestão de estoque
    canManageInventory: isOwner,
    canViewInventoryCosts: isOwner,
    
    // Operações básicas - todos podem fazer
    canCheckIn: true,
    canCheckOut: true,
    canCreateReservations: true,
    canViewRooms: true,
    canRegisterConsumption: true,
  };
};

// Hook para verificar se é proprietário
export const useIsOwner = (): boolean => {
  const { user } = useAuth();
  return user?.user_type === 'owner';
};

// Hook para verificar se é recepcionista
export const useIsReceptionist = (): boolean => {
  const { user } = useAuth();
  return user?.user_type === 'receptionist';
};
